export default "__VITE_ASSET__nXT0FUKb__"